// Non-component exports for VideoSourceCards, split out of the .tsx so the
// component file only exports components (react-refresh/only-export-components).

import { VIDEO_SOURCES, type VideoSource } from '@/constants/videoSources';

/** Categories for the top-level card grid */
export type VideoCategory = 'stock' | 'youtube' | 'ai_video' | 'ai_director';

/** Check if a video source belongs to the AI Videos category */
export function isAIVideoSource(source: VideoSource): boolean {
  return (
    source !== VIDEO_SOURCES.STOCK &&
    source !== VIDEO_SOURCES.YOUTUBE &&
    source !== VIDEO_SOURCES.AI_DIRECTOR
  );
}

/** Get the category for a video source */
export function getVideoCategory(source: VideoSource): VideoCategory {
  if (source === VIDEO_SOURCES.STOCK) return 'stock';
  if (source === VIDEO_SOURCES.YOUTUBE) return 'youtube';
  if (source === VIDEO_SOURCES.AI_DIRECTOR) return 'ai_director';
  return 'ai_video';
}
